import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, getUserInfo, setToken, setUserInfo, clearAuth } from '../utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken(),
    userInfo: getUserInfo(),
    customers: [],
    departments: [],
    users: []
  },
  mutations: {
    // 设置token
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
    },
    // 设置用户信息
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      setUserInfo(userInfo)
    },
    // 清空认证信息
    CLEAR_AUTH(state) {
      state.token = null
      state.userInfo = null
      clearAuth()
    },
    // 设置客户列表
    SET_CUSTOMERS(state, customers) {
      state.customers = customers
    },
    // 设置部门列表
    SET_DEPARTMENTS(state, departments) {
      state.departments = departments
    },
    // 设置用户列表
    SET_USERS(state, users) {
      state.users = users
    }
  },
  actions: {
    // 登录
    login({ commit }, userInfo) {
      commit('SET_TOKEN', userInfo.token)
      commit('SET_USER_INFO', userInfo.user)
    },
    // 退出登录
    logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    // 获取客户列表
    getCustomers({ commit }, customers) {
      commit('SET_CUSTOMERS', customers)
    },
    // 获取部门列表
    getDepartments({ commit }, departments) {
      commit('SET_DEPARTMENTS', departments)
    },
    // 获取用户列表
    getUsers({ commit }, users) {
      commit('SET_USERS', users)
    }
  },
  getters: {
    // 获取当前用户
    currentUser: state => state.userInfo,
    // 获取当前用户的部门ID
    currentDepartmentId: state => state.userInfo ? state.userInfo.department.id : null,
    // 判断用户是否已登录
    isLoggedIn: state => !!state.token && !!state.userInfo
  }
})